// extracted by mini-css-extract-plugin
export default {"eventTime":"PreMatchEventState_eventTime--tog"};